import React, {useState} from 'react';
import {FormHelperText, Typography} from '@material-ui/core';
import {When} from 'react-if';
import styles from './PlaceImagePicker.module.scss';
import Picker, {isNoImages} from './components/picker/Picker';
import {useWindowWidth,} from '@react-hook/window-size'
import {withSize} from 'react-sizeme';
import SkeletonPlaceHolder, {eSkeletonVariant} from 'gui/components/skeletonPlaceHolder';

interface IPlaceImagePickerProps {
  values?: any;
  submitCount?: any;
  errors?: any;
  setFieldValue?: any;
  size?: { width: number, height: number },
  placeKey: string;
  imagesPickKey: string;
}

const imagesCount = (props) => {
  const photos = props.values[props.placeKey].photos || [];
  const imagePick = props.values[props.imagesPickKey] || [];
  return `${imagePick.length}/${photos.length}`;
};
const PlaceImagePicker = (props: IPlaceImagePickerProps) => {
  const width = useWindowWidth();
  const error = props.submitCount > 0 && props.errors[props.imagesPickKey];
  const photos = props.values[props.placeKey].photos || [];
  if (isNoImages(photos)) {
    return null;
  }
  return (
    <div className={`${styles.PlaceImagePicker} ${(error ? `${styles.error} ` : "")}`}>
      <Typography variant="h6" component="h6" className={styles.topTitle}>
        תמונות מתוך גוגל(מומלץ לבחור תמונות איכותיות)
      </Typography>
      <input name={props.imagesPickKey} type="hidden"/>
      <When
        condition={!!error}>
        {() => <FormHelperText
          className={styles.error}
          error>{props.errors[props.imagesPickKey]}
        </FormHelperText>}
      </When>
      <Picker {...props} key={width}/>
      <p className={styles.imagesElected}>
        {props.values[props.placeKey].loading ?
          <SkeletonPlaceHolder variant={eSkeletonVariant.text} width={100}/> : imagesCount(props)}
      </p>
    </div>
  );
};

PlaceImagePicker.defaultProps = {
  imagesPickKey: "imagePick"
  //sizes: {width: width}
};

export default withSize()(React.memo(PlaceImagePicker)) as any;
